import React from 'react';

const SpikingAIFooterSticky = () => {
  return (
    <>
      <footer style={{ borderTop: '1px solid var(--line, #e5ebf3)', marginTop: '40px', padding: '40px 0', fontSize: '14px', lineHeight: '20px', fontWeight: 500, color: 'var(--muted, #5f6f85)' }}>
        <div className="container" style={{ display: 'flex', flexDirection: 'column'}}>
            <p style={{ fontWeight: 600, color: 'var(--text, #0e1726)' }}>Disclaimer: SpikingAI® for Informational Purposes Only</p>
            <p style={{ marginBottom: '12px' }}>
              SpikingAI® is provided solely for informational purposes and should not be construed as
              financial, investment, legal, or any other professional advice. The information generated
              by SpikingAI® is not intended to be, and should not be relied upon as, a basis for making
              investment or financial decisions.
            </p>

            <p style={{ fontWeight: 600, color: 'var(--text, #0e1726)' }}>1. No Prediction of Future Stock Prices</p>
            <p style={{ marginBottom: '12px' }}>
              SpikingAI® is not designed or intended to predict future stock prices or provide financial
              forecasting. Any perceived implication to the contrary is purely coincidental and not
              intentional.
            </p>

            <p style={{ fontWeight: 600, color: 'var(--text, #0e1726)' }}>2. Accuracy and Reliability of Information</p>
            <p style={{ marginBottom: '12px' }}>
              While SpikingAI® utilizes advanced artificial intelligence algorithms, the accuracy,
              reliability, and completeness of its generated content cannot be guaranteed. Users are
              responsible for independently verifying any information before acting upon it. The
              creators, affiliates, partners, and stakeholders of SpikingAI® assume no liability for
              inaccuracies, errors, or any actions taken based on the information provided.
            </p>

            <p style={{ fontWeight: 600, color: 'var(--text, #0e1726)' }}>3. No Affiliation with Microsoft or Google</p>
            <p>
              SpikingAI® is not endorsed by, affiliated with, or sponsored by Microsoft or Google. Any
              operational issues, inaccuracies, or faults within SpikingAI® cannot be attributed to these
              organizations.
            </p>
            <p style={{ marginBottom: '12px' }} >
              By using SpikingAI®, you acknowledge and agree to this disclaimer to the fullest extent
              permitted by law. For financial or investment decisions, always seek advice from a
              qualified professional.
            </p>

            <p>
              {' '}
              <span>
                Copyright © Spiking. All rights reserved. |{' '}
                <a
                  target="_blank"
                  href="https://spiking.com/terms"
                  rel="noreferrer"
                  style={{ textDecoration: 'underline' }}
                >
                  Terms
                </a>{' '}
              </span>
              |{' '}
              <a
                target="_blank"
                href="https://spiking.com/financialdisclaimer"
                rel="noreferrer"
                style={{ textDecoration: 'underline' }}
              >
                Not financial advice
              </a>
            </p>
        </div>
      </footer>
    </>
  );
};

export default SpikingAIFooterSticky;
